define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/storage",
	"csi/def/Action",
	"csi/def/Toolbar",
	"csi/reflection",
	"csi/table/Widget",
	"csi/view/ToolbarPluginToggleButton",
	"csi/xml",
	"csi/xml/Query"
], function(array,declare,lang,storage,Action,Toolbar,reflection,Widget,ToolbarPluginToggleButton,xml,Query) {

	var	_ShowRemarks = declare(ToolbarPluginToggleButton, {
		isToggledInitially: function(/*Context?*/ctx) {
			return ctx.view.bShowRemarks;
		}
	});

	return declare(Widget, {
		bShowRemarks: false,

		_resolveView: function() {
			// summary: add dependency paths for Calendar information
			var	defView = this.defView;
			var	a;

			function addDepPaths(index) {
				a.push("Child:Activities;Milestones");

				if (index == 0) {
					a.push("Child:__Parent__/Child:CalendarLevel");
					a.push("Child:__Parent__/Child:__Parent__/Child:CalendarLevel");
					a.push("Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:CalendarLevel");
					a.push("Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:CalendarLevel");
					a.push("Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:CalendarLevel");
					a.push("Child:__Parent__/Child:__Material__/Child:CalendarMSG/Child:CalendarLevel");

					a.push("Child:CalendarRollup");
					a.push("Child:Parent/Child:CalendarRollup;AllActivities");
					a.push("Child:Parent/Child:Parent/Child:CalendarRollup;AllActivities");
					a.push("Child:Parent/Child:Parent/Child:Parent/Child:CalendarRollup;AllActivities");
					a.push("Child:Parent/Child:Parent/Child:Parent/Child:Parent/Child:CalendarRollup;AllActivities");
				} else {
					a.push("Child:__Parent__/Child:CalendarLevel");
				}
			}

			a = defView.m_depPaths = defView.m_depPaths || [];
			a.push("Child:Master/Child:Activities/Child:Proto");
			a.push("Child:Master/Child:Proto/Child:Level/Child:AllLevels");

			if (defView.m_id == "CalendarActivities") {
				addDepPaths(0);
			} else {
				// add calendar remarks plugin
				defView.defToolbar = lang.mixin(new Toolbar(), {
					m_actions: [
						lang.mixin(new Action(), {
							m_id: "Show Remarks",
							m_postAction: function(ac) {
								storage.set("csi_ShowRemarksOnCalendar", ac.actionValue ? "true" : "false");
								ac.widget.bShowRemarks = ac.actionValue;
								ac.widget.refreshDataRows();
							},
							classToolbarPlugin: _ShowRemarks
						})
					]
				});

				// add dependency paths
				if (defView.m_root) {
					addDepPaths(0);
				}

				array.forEach(defView.m_relationships, function(r, i) {
					a = r.m_depPaths = r.m_depPaths || [];
					addDepPaths(i);
				});
			}

			this.bShowRemarks = storage.get("csi_ShowRemarksOnCalendar") == "true";
			this.inherited(arguments);
		}
	});
});